/**
 * 源站 rem（PC 1440 实测）：
 * - 窄屏：html.fontSize = clientWidth / 375 * 16（390 → 16.64px）
 * - ≥958px：fontSize=16px；中间壳 520px + 左右 #page3/#page4 遮罩（贴纸底图）
 */
const DESIGN_WIDTH = 375;
const ROOT_FONT = 16;
/** 与源站 `@media (min-width: 958px)` 对齐 */
export const LOR_US_PC_MIN_WIDTH = 958;
/** 源站宽屏壳宽（home / head / tabbar） */
export const LOR_US_PC_SHELL_WIDTH = 520;

export function applyLorUsRem() {
  const width = document.documentElement.clientWidth || window.innerWidth;
  const size =
    width >= LOR_US_PC_MIN_WIDTH ? ROOT_FONT : (width / DESIGN_WIDTH) * ROOT_FONT;
  document.documentElement.style.fontSize = `${size}px`;
  document.documentElement.dataset.lorUsRem = '1';
}

export function clearLorUsRem() {
  if (document.documentElement.dataset.lorUsRem !== '1') return;
  document.documentElement.style.fontSize = '';
  delete document.documentElement.dataset.lorUsRem;
}

export function bindLorUsRem() {
  applyLorUsRem();
  const onResize = () => applyLorUsRem();
  window.addEventListener('resize', onResize);
  return () => {
    window.removeEventListener('resize', onResize);
    clearLorUsRem();
  };
}
